// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import { isNullOrUndefined } from '/lib/helsecore/isNullOrUndefined';

type EmptyOrTypedArray<T> = T extends null | undefined
	? []
	: T[];

/**
	* Force arrays on single enonic objects
	* @param data Data to be wrapped in array
	* @returns Object wrapped in array
	*/
export function forceArray<T>(data: T | T[]): T extends null | undefined
	? []
	: T[]
{
	if (isNullOrUndefined(data)) {
		return [] as EmptyOrTypedArray<T>;
	}
	if (Array.isArray(data)) {
		return data as EmptyOrTypedArray<T>;
	}
	return [data] as unknown as EmptyOrTypedArray<T>;
}
